/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import SideBarNavigation from "../../Layouts/Sidebar/Sidebar";
import { Button } from "@mui/material";
import Header from "../../Layouts/AppHeader/Header";
import OrderTableComponent from "../../Layouts/Table/OrderTableComponent";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import CreatePurchaseOrder from "../CreateOrder/CreatePurchaseOrder";
import OrderHistoryComponent from "../../Layouts/Table/OrderHistoryComponent";

function SalesOrderHistory() {
  const [showCreateOrder, setShowCreateOrder] = useState(false);

  const handleCreateOrder = () => {
    setShowCreateOrder(true);
  };

  const handleBackToOrders = () => {
    setShowCreateOrder(false);
  };

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-1/6">
        <SideBarNavigation />
      </div>

      {/* Main Content */}
      <div className="w-5/6 bg-gray-50">
        {/* Header */}
        <Header merchantLogoUrl="" />

        <div className="p-8">
          {showCreateOrder ? (
            <CreatePurchaseOrder onBack={handleBackToOrders} />
          ) : (
            <>
              <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-semibold text-gray-800 ml-6">
                  Sales Orders
                </h1>
                <Button
                  variant="contained"
                  startIcon={<AddSharpIcon />}
                  sx={{
                    textTransform: "none",
                    bgcolor: "#171F21",
                    "&:hover": { bgcolor: "#0077F" },
                    fontSize: "16px",
                    borderRadius: "30px",
                    px: 3,
                    py: 1,
                  }}
                  onClick={handleCreateOrder}
                >
                  Add Order
                </Button>
              </div>

              {/* Order Table */}
              <div
                className="bg-white rounded-lg shadow-sm ml-6"
                style={{
                  boxShadow: "0px 7px 29px 0px #64646F33",
                  borderRadius: "8px",
                }}
              >
                <OrderHistoryComponent />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SalesOrderHistory;
